module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_08-d78863b72aa644d5dd6d32eaeb3c2cf3.png";